import { Route, Routes, useLocation } from 'react-router-dom'
import TopNavBar from './components/TopNavBar'
import './App.css'
import Home from './screens/Home'
import SideDrawer from './components/SideDrawer'
import DemoGallery from './screens/DemoGallery'
import BarChart from './screens/BarCharts/BarChart'
import StackedBar from './screens/BarCharts/StackedBar'
import HorizBar from './screens/BarCharts/HorizBar'
import BottomTab from './components/BottomTab'
import React, { useState, useEffect, createContext, useContext } from 'react'
import {
  FaGithub,
  FaExpandArrowsAlt,
  FaCompress,
  FaCompressArrowsAlt,
  FaMoon,
  FaSun,
} from 'react-icons/fa'
import LineChart from './screens/LineCharts/LineChart'
import AreaChart from './screens/LineCharts/AreaChart'
import PieChart from './screens/PieChart'
import BarChartGallery from './screens/Gallery/BarChart'
import LineChartGallery from './screens/Gallery/LineChart'
import PieChartGallery from './screens/Gallery/PieChart'
import BarCharts from './screens/BarCharts'
import LineCharts from './screens/LineCharts'
import PopulationPyramid from './screens/PyramidCharts/PopulationPyramid'
import { AppContext } from './AppContext'
import { appConstants } from './constants'
import RadarChart from './screens/RadarCharts'
import BubbleChart from './screens/LineCharts/BubbleChart'
import CandleStick from './screens/BarCharts/CandleStick'

function App() {
  const { mobileMaxWidth } = appConstants
  const [theme,setTheme] = useState('dark')
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const isMobile = width < mobileMaxWidth
  const [hideRightNav, setHideRightNav] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState(false)

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth)
    window.addEventListener('resize', updateWindowHeight)
    return () => {
      window.removeEventListener('resize', updateWindowWidth)
      window.removeEventListener('resize', updateWindowHeight)
    }
  }, [])

  const [selected, setSelected] = useState('')
  let location = useLocation()

  useEffect(() => {
    let urlsArray = location.pathname.split('/')
    if (urlsArray.length > 1) {
      if (urlsArray.some((urls) => urls.startsWith('gallery'))) {
        setSelected('/gallery')
      } else if (urlsArray.some((urls) => urls === 'barchart')) {
        setSelected('/barchart')
      } else if (urlsArray.some((urls) => urls === 'horizbar')) {
        setSelected('/horizbar')
      } else if (urlsArray.some((urls) => urls === 'stackbar')) {
        setSelected('/stackbar')
      } else if (urlsArray.some((urls) => urls === 'candlestick')) {
        setSelected('/candlestick')
      }
       else if (urlsArray.some((urls) => urls === 'linechart')) {
        setSelected('/linechart')
      } else if (urlsArray.some((urls) => urls === 'areachart')) {
        setSelected('/areachart')
      } else if (urlsArray.some((urls) => urls === 'piechart')) {
        setSelected('/piechart')
      } else if (urlsArray.some((urls) => urls === 'radarchart')) {
        setSelected('/radarchart')
      } else if (urlsArray.some((urls) => urls === 'popnpyramid')) {
        setSelected('/popnpyramid')
      } else {
        setSelected('/')
      }
    } else {
      setSelected('/')
    }
  }, [location.pathname])

  const updateWindowWidth = () => {
    setWidth(window.innerWidth)
  }
  const updateWindowHeight = () => {
    setHeight(window.innerHeight)
  }

  const newAppContext = {
    height,
    width,
    hideRightNav,
    setHideRightNav,
    theme
  }

  const toggleExpand = () => {
    setIsFullScreen((isFull) => !isFull)
  }

  const getToggleButtonsPosition = () => {
    if (isFullScreen) return 10
    if (
      [
        '/barchart',
        '/horizbar',
        '/stackbar',
        '/candlestick',
        '/linechart',
        '/areachart'
      ].includes(selected)
    )
      return 100
    return 50
  }

  const fullScreenButton = () => {
    return (
      <>
        {isMobile && selected !== '/' ? (
          <div
            className='expandButton'
            onClick={toggleExpand}
            style={{ top: getToggleButtonsPosition(), color: 'lightgray' }}
          >
            {isFullScreen ? <FaCompressArrowsAlt /> : <FaExpandArrowsAlt />}
          </div>
        ) : null}
      </>
    )
  }

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'))
  }

  return (
    <AppContext.Provider value={newAppContext}>
      <div className='app'
        style={theme === 'dark' ? {backgroundColor: '#1f252b', color: 'lightgray'} : {}}
      >
        {fullScreenButton()}
        {isFullScreen ? null : (
          <>
           <div onClick={toggleTheme} className='theme' style={isMobile?{right:68, top:12}:{right:120, top:22}}>
            {theme === 'dark' ? <FaSun fontSize={isMobile?14:22} color='white'/> : <FaMoon fontSize={isMobile?14:22} color='white'/>}
          </div>
            <a
              className='git'
              style={{ top: isMobile ? 8 : 16, fontSize: isMobile ? 26 : 36 }}
              href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts'
              target='_blank'
              rel='noreferrer'
            >
              <FaGithub />
            </a>
            <a
              className='npm'
              style={{ top: isMobile ? 12 : 20 }}
              href='https://www.npmjs.com/package/react-native-gifted-charts'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={require('./assets/npm.png')}
                className={isMobile ? 'npmLogoMobile' : 'npmLogo'}
                alt=''
              />
            </a>
            <TopNavBar isMobile={isMobile} />
          </>
        )}
        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
          {width > 1100 && <SideDrawer height={height} />}
          <Routes>
            <Route path='/' element={<Home isMobile={isMobile} />} />
            <Route path='/gallery' element={<DemoGallery isMobile={isMobile} />} />
            <Route
              path='/barchart'
              element={
                isMobile ? (
                  <BarCharts tab={0} isFullScreen={isFullScreen} />
                ) : (
                  <BarChart />
                )
              }
            />
            <Route
              path='/horizbar'
              element={
                isMobile ? (
                  <BarCharts tab={1} isFullScreen={isFullScreen} />
                ) : (
                  <HorizBar />
                )
              }
            />
            <Route
              path='/stackbar'
              element={
                isMobile ? (
                  <BarCharts tab={2} isFullScreen={isFullScreen} />
                ) : (
                  <StackedBar />
                )
              }
            />
            <Route
              path='/candlestick'
              element={
                isMobile ? (
                  <BarCharts tab={3} isFullScreen={isFullScreen} />
                ) : (
                  <CandleStick />
                )
              }
            />
            <Route
              path='/linechart'
              element={
                isMobile ? (
                  <LineCharts tab={0} isFullScreen={isFullScreen} />
                ) : (
                  <LineChart />
                )
              }
            />
            <Route
              path='/areachart'
              element={
                isMobile ? (
                  <LineCharts tab={1} isFullScreen={isFullScreen} />
                ) : (
                  <AreaChart />
                )
              }
            />
            <Route
              path='/bubblechart'
              element={
                isMobile ? (
                  <LineCharts tab={2} isFullScreen={isFullScreen} />
                ) : (
                  <BubbleChart />
                )
              }
            />
            <Route path='/piechart' element={<PieChart isMobile={isMobile} />} />
            <Route path='/radarchart' element={<RadarChart isMobile={isMobile} />} />
            <Route
              path='/popnpyramid'
              element={<PopulationPyramid isMobile={isMobile} />}
            />
            <Route path='/gallerybar' element={<BarChartGallery isMobile={isMobile}  />} />
            <Route path='/galleryline' element={<LineChartGallery isMobile={isMobile} />} />
            <Route path='/gallerypie' element={<PieChartGallery isMobile={isMobile} />} />
          </Routes>
          </div>
        {!isFullScreen && width < 1100 && <BottomTab isMobile={isMobile} />}
      </div>
    </AppContext.Provider>
  )
}

export default App
